<template>
  <div>
    <div v-show="booleanPop" class="pop_box">
      <!-- <div class="pop_content">
        <img src="@/assets/img/headset.png" alt="" class="img_">
        <div class="text">{{ popMsg }}</div>
        <div class="btn" @click="hidePop">确认</div>
      </div> -->
      <div class="pop_content">
        <!-- <img src="@/assets/img/headset.png" alt="" class="img_"> -->
        <div class="pop_content_tw">
          <img src="@/assets/transcript/red_envelopese.png" alt="" class="img_">
          <p class="text">{{ popMsg }}</p>
        </div>
        <img class="img_c" src="@/assets/transcript/dred_envelopese.png" alt="" @click="hidePop">
        <p class="close_select">
          <img v-show="tick" src="@/assets/transcript/select.png" alt="" @click="tickClick()">
          <img v-show="!tick" src="@/assets/transcript/unchecked.png" alt="" @click="tickClick_no()">
          <span>下次不再提醒,不再获得筑龙币</span>
        </p>
      </div>
    </div>
    <div class="videos">
      <img class="back" src="@/assets/img/back2x.png" alt="" style="width: 28px;height:28px;" @click="goBack">
      <div v-show="!uid" class="no_login">
        <div class="lesson_thumb" :style="`background:url(${thumb})`"></div>
        <h3 class="unload">您还未登录，需要登录才能观看哦~</h3>
        <h1 class="no_login_btn" @click="go_login">注册/登录</h1>
      </div>
      <div v-show="!is_under&&is_vshow == 0&&is_shelf==0&&uid" class="Unpaid">
        <div class="lesson_thumb" :style="`background:url(${thumb})`"></div>
        <div class="ermsg">
          <p v-if="vip_type==0" class="errMsg">该视频需要购买课程，才能观看哦～ </p>
          <p v-if="vip_type==1&&!is_vip" class="errMsg">该视频需要购买课程，才能观看哦～</p>
          <p v-if="vip_type==1&&is_vip" class="errMsg">该视频需要购买VIP，才能观看哦～</p>
          <button v-if="vip_type==1&&is_vip" class="apply" @click="upgrade()">升级VIP</button>
          <button v-if="vip_type==1&&is_vip==0" class="apply" @click="go_buy()">购买课程</button>
          <!-- <button v-if="is_xly===1" class="apply" @click="go_sqsx()">申请试学</button> -->
          <button v-if="vip_type!=1&&(is_xly==0||is_xly==1)" class="apply" @click="go_buy()">购买课程</button>
          <img v-if="is_collect==0" class="xing_imgs" src="@/static/images/uncollect.png" alt @click="mygetCollectLesson">
          <img v-if="is_collect" class="xing_imgs" src="@/static/images/collect.png" alt @click="mygetCollectLesson">
          <img v-show="!isInApp" class="mores" src="@/assets/img/more.png" alt="" @click="showMore()">
        </div>
        <commontop v-show="isMore"></commontop>
      </div>
      <div v-show="(!is_under&&is_vshow == 1&&is_update)||(!(is_under&&auth==0)&&is_shelf==-1)" class="Unpaid">
        <div class="ermsg">
          <p class="errMsg">该课程小节正在更新中</p>
        </div>
      </div>
      <div v-show="is_under&&auth==0" class="Unpaid">
        <div class="ermsg">
          <p class="errMsg">该课程已下架</p>
        </div>
      </div>
      <div v-show="is_vshow == 1&&auth==1" id="test"></div>
    </div>
    <div class="all">
      <van-tabs v-model="active" style="width: 50%" title-active-color="#ee2d2e">
        <van-tab title="简介">
          <div class="section_title">
            <p>{{ section_title }}</p>
          </div>
          <div v-if="section_info !=='' " class="section_info" v-html="section_info"></div>
          <div v-else class="no_info">本视频暂时没有视频简介</div>
        </van-tab>
        <van-tab title="问答">
          <div class="wd_main">
            <div v-if="Qalist !==undefined && Qalist.length > 0" class="wd_lists">
              <div v-for="(item,index) in Qalist" :key="index" class="qd_item">
                <div class="item_left">
                  <img class="avatar" :src="item.avatar" alt>
                </div>
                <div class="item_cnt">
                  <p class="username">{{ item.username }}</p>
                  <p class="message">{{ item.content }}</p>
                  <p class="date_str">{{ item.create_time }}</p>
                </div>
              </div>
            </div>
            <div v-else class="wd_kong">
              <img src="@/assets/new_kong.png" alt>
              <p>发问题互动吧~</p>
            </div>
          </div>
          <div class="footers">
            <input v-model="Qacontent" type="text" placeholder="发布问题一起互动">
            <button @click="sendQa">发送</button>
          </div>
        </van-tab>
      </van-tabs>
      <div class="menu_items">
        <p class="lesson" @click="goDatail()">课程详情</p>
        <p v-show="auth === 1 && has_video_exercise === 1" class="reviewing" @click="goStpc()">随堂评测</p>
      </div>
    </div>
    <van-overlay :show="jbshow" class="jb-style">
      <p>恭喜您获得<span>{{ jbNum }}</span>金币</p>
      <img class="loading-image" :src="`https://newoss.zhulong.com/edu/202112/21/27/1835271ayp9do3dh4phe9s.gif`+'?+' + sui" alt="">
      <!-- <img src="@/assets/classlist/gb.png" alt="" @click="hidePopJb"> -->
    </van-overlay>
  </div>
</template>

<script src="https://p.bokecc.com/player?siteid=2661F9756E5C832E&newversion=true"></script>

<script>
import Cookies from 'js-cookie'
import { getVideoInfo, getQAlist, sends, statistic } from "@/api/videos.js";
import { videoPop, addScore, getUserPopup, setUserPopup } from '@/api/hometop.js'
import { getCollectLesson } from '@/api/collect.js'
import { Toast } from 'vant';
import tool from '@/utils/tools.js'
import commontop from '@/components/common/menu.vue'
export default {
  components: {
    commontop
  },
  data() {
    return {
      booleanPop: false,
      popMsg: '',
      is_xly: 0,
      is_vip: 0,
      lesson_id: '',
      page_url: '',
      is_vshow: 1,
      vip_type: 0,//是否为vip课程
      test: '',
      player: '',
      active: 0,
      sqsxUrl: "",
      playurl: {
        cc_id: "",
        cc_uid: "",
        check_code: "",
        payer_name: "",
      },
      canget: 0,
      Qatitle: "",
      Qacontent: "",
      Qalist: [],
      section_title: '',
      section_info: '',
      has_video_exercise: 0,
      auth: 0,
      is_under: 0,
      is_update: false,
      isInApp: false,
      isMore: false,
      getPopTimer: null,
      tick: '', // 防作弊是否勾选
      is_cancel: 0,
      jbshow: false,
      jbNum: '',
      sui: '',
      is_shelf: '',
      thumb: '',

      uid: '',
      username: '',
      playTime: '',
      allTime: '',
      next_url: '',
      invervalRecord: null,
      u: '',
      terminal: '',
      videoList: [],
      exercise_url: '',
      is_collect:0,
    };
  },
  created() {
    this.uid = Cookies.get('uid')
    this.username = Cookies.get("username");
    this.lesson_id = this.$route.query.lesson_id
    this.page_url = window.location.href
    if(this.auth){
      this.invervalRecord = setInterval(this.intervalTime, 3000);
    }
  },
  mounted() {
    this.u = navigator.userAgent;
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      this.terminal = 1;
    } else {
      this.terminal = 0;
    }
    if (tool.isInApp()) {
      this.isInApp = true
    } else {
      this.isInApp = false
    }
    this.getQaList()
    this.get_video()
    if (window.ccH5PlayerJsLoaded) {
      this.createPlayer();
    }
    if (this.$route.query.from === 'schedule') {
      localStorage.setItem('continue_learn', location.href)
    }
  },
  beforeDestroy() {
    clearInterval(this.invervalRecord);
    this.clearTimer()
  },
  methods: {
    // 递归获取所有视频类型数据
    getAllVideo(arr) {
      var videoArr = []
      arr.map((ele) => {
        ele.len = arr.length
        if (!ele.children.length) {
          return
        }
        if (ele.children.length > 0) {
          ele.children.forEach((item) => {
            if (item.courseware_type == 2) {
              videoArr.push(item)
            }
          })
        }
        if (ele.children.length > 0) {
          this.getAllVideo(ele.children)
        } else {
          return
        }
      })
      return videoArr
    },
    intervalTime() {
      //每3秒获取一次时间
      this.recordTime();
    },
    hidePop() {
      const info = {
        type: 4,// 1：安卓，2：IOS，3：H5，4：PC
        action_type: 32,  // action_type 视频32  ,  直播 31
        live_type: 2,  // live_type 视频 2  ,  直播 1
        is_cancel: this.is_cancel,
        lesson_id: this.$route.query.lesson_id,
        wk_id: this.$route.query.wk_id,
      }
      addScore(info).then(res => {
        console.log(res, 'res')
        if (res.errNo == 0) {
          // this.jbNum = res.result
          this.jbshow = true
          this.jbNum = 0
          let media = res.result
          this.timer = setInterval(() => {
            if (media < 1) {
              var timer1 = setTimeout(() => {
                this.canget = 0
                this.jbshow = false
                this.player.play()
                clearTimeout(timer1)
              }, 4000)
              clearInterval(this.timer)
              this.timer = null
            } else {
              media--
              this.jbNum++
            }
          }, 30)
        } else {
          this.jbNum = 0
          this.player.play()
        }
      })
      this.sui = Math.random()
      if (this.tick == true) {
        this.is_cancel = 1
        this.setPopUpStatus()
      }
      this.booleanPop = false
    },
    hidePopJb() {
      // console.log(this.player.getVideoState());
      // console.log(this.player.getCurrRate());
      // console.log(this.player.getPosition());
      // this.player.pause()
      this.canget = 0
      this.jbshow = false
      this.player.play()
    },
    tickClick() {
      this.tick = false
      this.is_cancel = 0
    },
    tickClick_no() {
      this.tick = true
      this.is_cancel = 0
    },
    // 视频弹窗
    videoPopFun() {
      if (this.is_cancel != 1) {
        if (this.player.getVideoState() === 'play') {
          let data = {
            type: 3,// 1：安卓，2：IOS，3：H5，4：PC
            lesson_id: this.$route.query.lesson_id,
            wk_id: this.$route.query.wk_id,
            times: this.player.getCurrRate(),
            progress: parseInt(this.player.getPosition()),
            watch_progress: parseInt(this.player.getPosition())
          }
          videoPop(data).then(res => {
            if (window.orientation == 180 || window.orientation == 0) {//竖屏显示
              if (res.result.is_pop) {
                this.popMsg = res.result.msg
                this.booleanPop = true
                this.player.pause()
              }
            }
          })
        }
      }
    },
    goBack() {
      this.$router.go(-1)
    },
    // 立即购买
    go_buy() {
      location.href = `/shop/pay/?product_type=${1}&product_id=${this.lesson_id}&fromurl=${this.page_url}&f_code=${''}`
    },
    // 升级vip
    upgrade() {
      location.href = `/shop/pay/?product_type=${3}&product_id=${this.lesson_id}&fromurl=${this.page_url}&f_code=${''}`
    },
    //获取视频信息
    get_video() {
      var params = {
        lesson_id: this.$route.query.lesson_id,
        wk_id: this.$route.query.wk_id
      };
      getVideoInfo(params).then((res) => {
        // 设置title标题
        this.is_collect = res.result.is_collect
        this.vip_type = res.result.vip_type
        this.is_xly = res.result.is_xly
        this.is_vip = res.result.is_vip
        this.is_under = res.result.is_under
        // this.is_under = 1
        const my_title = document.getElementsByTagName('title')[0]
        my_title.innerHTML = res.result.seo.seo_title
        this.sqsxUrl = res.result.try_learn_url
        this.is_shelf = res.result.info.is_shelf
        this.thumb = res.result.info.thumb
        // 数据
        let result = res.result || {}
        // 评测链接
        this.exercise_url = result.exercise_url || ''

        this.next_url = res.result.info.next_url
        if(this.next_url==''){
          this.next_url = window.origin + '/home?lesson_id=' + this.lesson_id
        }

        // 课表
        // let schedule = res.result.lesson_schedule || []
        // if (schedule.length > 0) {
        //   this.videoList = this.getAllVideo(schedule)
        // } else {
        //   this.videoList = []
        // }
        // // 查找是否是最后一个
        // for (let i = 0; i < this.videoList.length; i++) {
        //   if (this.videoList[i].courseware_id == this.$route.query.wk_id) {
        //     // 如果是最后一个则播放第一个
        //     if (i == this.videoList.length - 1) {
        //       this.next_url = window.location.protocol + '//' + window.location.host + '/edu/d/' + this.lesson_id + '.html#i=1'
        //     } else {
        //       this.next_url = window.location.protocol + '//' + window.location.host + '/edu/play?lesson_id=' + this.lesson_id + '&wk_id=' + this.videoList[i + 1].courseware_id
        //     }
        //     break
        //   }
        // }
        // 如果有cc_id
        if (res.result.info.cc_id) {
          this.is_update = false
          if (res.result.auth == 0) {
            this.$set(this.playurl, 'cc_id', null)
            // 如果没下架
            if (this.is_under == 0) {
              // 显示购买
              this.is_vshow = 0;
              this.is_under = 0
            } else {
              this.is_under == 1
            }

          } else {
            this.is_vshow = 1;
            this.$set(this.playurl, 'cc_id', res.result.info.cc_id)
            this.$set(this.playurl, 'cc_uid', res.result.info.cc_new_uid)
            this.$set(this.playurl, 'check_code', res.result.info.check_code)
            this.$set(this.playurl, 'payer_name', res.result.info.payer_name)
            this.$set(this.playurl, 'auth', res.result.info.auth)
            if (res.result.info.is_shelf == -1) {
              this.$set(this.playurl, 'cc_id', null)
            }
          }
        } else {
          console.log('你他麻痹的');
          // 没有cc_id
          // 没有权限
          if (res.result.auth == 0) {
            if (this.is_under) {
              // 如果已经下架
              // 显示该课程已下架
              this.is_under = 1
              this.is_vshow == 1
              this.is_update = false
            } else {
              // 无权限没下架
              // 不展示下架
              this.is_under = 0
              // 展示小节更新
              this.is_update = false
              this.is_vshow == 0
            }
          } else {
            this.is_update = true
          }
        }

        var data = res.result;
        this.section_title =
          //   "第" +
          //   data.info.chapter_sort +
          //   "-" +
          data.info.section_sort +
          // "节 " +
          data.info.section_name;
        this.section_info = data.info.video_desc ? data.info.video_desc : '';
        this.auth = data.auth
        // this.auth = 0
        this.has_video_exercise = data.has_video_exercise
      }).then(() => {
        this.createPlayer()
        // this.setPlayerCallBack()
      })
    },
    sendQa() {
      var params = {
        lesson_id: this.$route.query.lesson_id,
        section_id: this.$route.query.wk_id,
        title: this.Qatitle,
        content: this.Qacontent,
        question_id: "",
        to_username: ""
      }
      sends(params).then(res => {
        if (res.errNo === 0) {
          this.Qacontent = ''
          this.getQaList()
        }
        console.log(res)
      })
    },
    getQaList() {
      var params = {
        lesson_id: this.$route.query.lesson_id,
        section_id: this.$route.query.wk_id,
      };
      getQAlist(params).then(res => {
        this.Qalist = res.result.a_list
        console.log(this.Qalist);

      })
    },
    goDatail() {
      window.location.href = `${window.origin}/home?lesson_id=${this.$route.query.lesson_id}`
    },
    go_sqsx() {
      window.location.href = this.sqsxUrl
    },
    goStpc() {
      window.location.href = this.exercise_url
      // this.$router.push({
      //   path: '/reviewing',
      //   query: {
      //     lesson_id: this.$route.query.lesson_id,
      //     video_id: this.$route.query.video_id,
      //     chapter_id: this.$route.query.chapter_id,
      //     type: '1'
      //   }
      // })
    },
    mygetCollectLesson() {
      var params = {
        lesson_id: this.$route.query.lesson_id
      }
      getCollectLesson(params).then(res => {
        if (res.errNo === 0) {
          Toast(res.result);
          this.get_video()
        }
      })
    },
    get_cc_verification_code(vid) {
      return this.playurl.auth
    },
    setPlayerCallBack() {
      window.onCCH5PlayerLoaded = this.onCCH5PlayerLoaded;
      window.on_CCH5player_ready = this.onPlayerReady;
      window.on_player_timeupdate = this.on_player_timeupdate;
      window.get_cc_verification_code = this.get_cc_verification_code;
      window.on_CCH5player_ended = this.on_CCH5player_ended;
    },
    // 跳登录
    go_login(){
      window.location.href = '/login?redirect=' + window.location.href
    },
    onCCH5PlayerLoaded() {
      // 播放器js文件加载完成时回调
      window.ccH5PlayerJsLoaded = true;
      this.createPlayer();
    },
    onPlayerReady() {
      // 初始化完成之后的回调
      this.playTime = window.cc_js_Player.getPosition();
      this.allTime = window.cc_js_Player.getDuration();
    },
    on_player_timeupdate(currentTime, vid) {
      this.playTime = currentTime;
    },
    on_CCH5player_ended() {
      console.log('播放完了');
      this.recordTime();
      if (this.next_url) {
        location.href = this.next_url
      }
    },
    createPlayer() {
      this.test = document.getElementById("test");
      this.player = window.createCCH5Player({
        vid: this.playurl.cc_id,
        siteid: this.playurl.cc_uid,
        // siteid: '73F7E4126ED2C1D5',
        autoStart: "true",
        width: "100%",
        height: "100%",
        parentNode: this.test,
        isShare: "false", // 分享
        isShowRightMenu: "true",
      });
      this.setPlayerCallBack();
      this.popUpStatus()
    },

    // 展示更多
    showMore() {
      if (this.isMore === false) {
        this.isMore = true
      } else {
        this.isMore = false
      }
    },
    // 设置不再弹出弹框
    setPopUpStatus() {
      const popup = 0
      const info = {
        is_popup: popup
      }
      setUserPopup(info).then(res => {
        this.clearTimer()
      })
    },
    // 请求状态
    popUpStatus() {
      getUserPopup().then(res => {
        if (res.errNo === 0) {
          if (res.result.is_popup === 1) {
            this.creatPopTimer()
          }
        }
      })
    },
    // 创建弹窗定时器
    creatPopTimer() {
      this.getPopTimer = setInterval(() => {
        // console.log('定时器');
        if (this.canget === 0) {
          this.canget++
        } else {
          this.videoPopFun()
        }
      }, 30000)
    },

    // beforeDestroy(){

    // },
    // 销毁定时器
    clearTimer() {
      clearInterval(this.getPopTimer)
      this.getPopTimer = null
    },
    recordTime() {
      //记录播放时间
      const info = {
        lesson_id: this.lesson_id,
        wk_id: this.$route.query.wk_id,
        username: this.username,
        watch_time: parseInt(this.playTime),
        terminal: this.terminal,
      };
      statistic(info).then((res) => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.pop_box {
  background-color: rgba(0, 0, 0, 0.45);
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  display: flex;
  justify-content: center;
  align-items: center;
  .pop_content {
    width: 548px;
    height: 362px;
    // border-radius: 20px;
    background-image: linear-gradient(144deg, #ffffff 0%, #ffece7 100%);
    border-radius: 10px;
    border-radius: 10px;
    .pop_content_tw {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      .img_ {
        // display: block;
        width: 140px;
        // margin: 60px auto;
        // margin-top: 60px;
      }
      .text {
        width: 260px;
        word-wrap: break-word;
        word-break: normal;
        margin-left: 20px;
        font-family: PingFangSC-Regular;
        font-size: 26px;
        color: #333333;
        letter-spacing: 0;
      }
    }
    .img_c {
      width: 400px;
      height: 70px;
      margin: auto;
      display: block;
      cursor: pointer;
      // background-image: linear-gradient(144deg, #FF6F1D 0%, #FF4010 100%);
      // box-shadow: 0 2px 5px 0 rgba(152,34,0,0.31);
      // border-radius: 17px;
      // border-radius: 17px;
    }
    .close_select {
      text-align: center;
      margin-top: 20px;
      display: flex;
      justify-content: center;
      align-items: Center;
      img {
        width: 22px;
        height: 22px;
        margin-right: 20px;
        cursor: pointer;
      }
      span {
        font-family: PingFangSC-Regular;
        font-size: 24px;
        color: #999999;
        letter-spacing: 0;
        text-align: center;
      }
    }
  }
  // .pop_content{
  //   width: 560px;
  //   // height: 400px;
  //   border-radius: 20px;
  //   background-color: rgba(255, 255, 255, .95);
  //   .img_{
  //     display: block;
  //     width: 100px;
  //     margin: 60px auto;
  //     // margin-top: 60px;
  //   }
  //   .text{
  //     text-align: center;
  //     font-size: 34px;
  //     margin-bottom: 60px;
  //   }
  //   .btn{
  //     line-height: 100px;
  //     font-family: PingFangSC-Medium;
  //     font-size: 38px;
  //     color: #EE2E2E;
  //     letter-spacing: 0;
  //     text-align: center;
  //     border-top: 1px solid #DEDEDE;
  //   }
  // }
}
#test {
  height: 100%;
}
.xing_imgs {
  width: 56px;
  height: 58px;
  position: absolute;
  z-index: 1000;
  right: 8px;
  top: 20px;
}
.ermsg {
  text-align: center;
  position: relative;
}
.errMsg {
  color: #fff;
  font-size: 28px;
  padding-top: 150px;
}
.apply {
  color: #fff;
  background: #ee2e2e;
  width: 150px;
  height: 46px;
  border-radius: 30px;
  margin: 60px 10px 10px 0;
}
.no_login{
  width: 100%;
  height: 422px;
  background-color: #000;
  position: absolute;
  z-index: 1501;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .unload{
    color: #fff;
    font-size:28px;
    position:relative;
    z-index:5;
    margin-bottom:60px;
  }
  .lesson_thumb{
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-size: cover !important;
    background-repeat:no-repeat !important;
    filter: brightness(40%);
  }
}
.no_login_btn{
  line-height: 50px;
  padding: 0 40px;
  font-size: 30px;
  color: #fff;
  background-color: #ee2d2e;
  border-radius: 999px;
  position:relative;
  z-index:5;
}
.Unpaid {
  position: absolute;
  top: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: #333333;
  .lesson_thumb {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    filter: brightness(40%);
  }
}
.all {
  width: 100%;
  position: relative;
  border-bottom: 2px #d1d1d1 solid;
  height: 88px;
}
.videos {
  position: relative;
  width: 100%;
  height: 422px;
  background: #ccc;
}
.menu_items {
  position: absolute;
  right: 23px;
  bottom: 20px;
  .lesson {
    display: inline-block;
    color: #ee2d2e;
    border: 2px solid #f1f1f1;
    padding: 3px 15px;
    border-radius: 50px;
  }
  .reviewing {
    margin-left: 20px;
    display: inline-block;
    color: #ee2d2e;
    border: 2px solid #f1f1f1;
    padding: 3px 15px;
    border-radius: 50px;
  }
}
.footers {
  width: 100%;
  height: 90px;
  position: fixed;
  bottom: 0;
  left: 0;
  overflow: hidden;
}
.footers input {
  width: calc(100% - 200px);
  height: 63px;
  background: #f1f5f8;
  margin-left: 25px;
  margin-top: 8px;
  padding-left: 15px;
  float: left;
}
.footers button {
  float: left;
  width: 110px;
  height: 64px;
  background: #ee2d2e;
  color: #fff;
  margin: 8px 0 0 25px;
  font-size: 24px;
}

.section_title {
  width: 96vw;
  padding: 10px 2vw;
  font-weight: 600;
  background: #e7e7e7;
  margin-bottom: 30px;
  p {
    color: #333;
    font-size: 28px;
  }
}
.section_info {
  width: 96vw;
  padding: 0px 2vw;
  text-align: left;
  padding-bottom: 20px;
  line-height: 1.8;
  color: #333;
  font-size: 28px;
}
.section_info /deep/ img {
  display: block;
  width: 100% !important;
  -webkit-user-drag: none;
}
.no_info {
  width: 96vw;
  padding: 0px 2vw;
  text-align: left;
  line-height: 1.8;
  color: #333;
  font-size: 28px;
}
.wd_kong {
  text-align: center;
  margin-top: 25%;
  width: 100vw;
  p {
    margin-top: 20px;
    color: #333;
    font-size: 24px;
  }
}
.wd_main {
  width: 100vw;
  margin-bottom: 90px;
}
.qd_item {
  width: 100%;
  display: flex;
  flex-direction: row;
  border-bottom: 1px solid #eee;
  .item_left {
    width: 90px;
    margin-top: 20px;
    margin-left: 20px;
    .avatar {
      width: 90px;
      height: 90px;
      border-radius: 50%;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .item_cnt {
    margin-left: 20px;
    width: calc(100% - 145px);
    margin-bottom: 20px;
    .username {
      height: 40px;
      margin-top: 45px;
      color: #333;
      font-size: 24px;
    }
    .message {
      margin-top: 15px;
      width: 100%;
      color: #333;
      font-size: 24px;
    }
    .date_str {
      margin-top: 15px;
      width: 100%;
      color: #999;
      font-size: 24px;
    }
  }
}
.back {
  position: absolute;
  z-index: 1000;
  top: 20px;
  left: 10px;
}
.mores {
  position: absolute;
  z-index: 1000;
  top: 20px;
  right: 70px;
  width: 60px;
  height: 60px;
}
.jb-style {
  z-index: 99999;
  p {
    font-size: 30px;
    color: #fff;
    position: absolute;
    top: 20%;
    left: 35%;
    span {
      font-size: 44px;
      color: #ffe16d;
    }
  }
  img {
    width: 100%;
    // height: 100%;
  }
  // img:last-child{
  //   position: absolute;
  //   width: 30px;
  //   top: px;
  //   height: 30px;
  //   bottom: 25%;
  //   left: 50%;
  //   cursor: pointer;
  // }
}
</style>
